var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBfcWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1923 12.0031C23.2829 11.565 23.3309 11.1124 23.3309 10.6511C23.3362 6.27904 19.2652 3.08076 15.117 4.23905L4 7.34225L9.56462 16.6605L20.2391 13.6813C20.3809 13.6416 20.5238 13.6084 20.6683 13.5818C20.0339 14.4528 19.1298 15.0836 18.1005 15.3739L6.3428 18.6817L11.9063 28L23.2275 24.8139C26.0516 24.0185 28 21.3976 28 18.4152C28.0042 16.9598 27.5357 15.5437 26.6668 14.385C25.7979 13.2262 24.5772 12.3893 23.1923 12.0031ZM21.6246 10.6479C21.6299 7.3987 18.6128 5.05553 15.569 5.9051L6.62692 8.40209L10.3562 14.6471L19.786 12.0141C20.3431 11.8578 20.9183 11.7774 21.4961 11.7751C21.5798 11.4112 21.6246 11.0351 21.6246 10.6479ZM20.9476 15.7772C20.2466 16.3621 19.4326 16.7919 18.5579 17.0389L8.96652 19.7371L12.6969 25.9832L22.7712 23.1478C23.7877 22.8573 24.6827 22.2373 25.3192 21.3828C25.9557 20.5281 26.2984 19.4858 26.2952 18.4152C26.2995 17.3183 25.9408 16.2519 25.2755 15.3865C24.6108 14.5211 23.6785 13.9069 22.6278 13.6425C22.2211 14.4651 21.6486 15.1923 20.9476 15.7772Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBfcWhite);
export default __webpack_public_path__ + "static/media/bfc-white.ce39817cecca46abe11c31b8913fd2f5.svg";
export { ForwardRef as ReactComponent };